import { createSlice } from "@reduxjs/toolkit";
import subscribedStatus from "../../../rtk-apis/subscription/subscribedStudyStatus"

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const subscribedStatusSlice = createSlice({
  name: "subscribedStatusSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(subscribedStatus.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(subscribedStatus.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.data;
        state.msg = payload.msg;
      })
      .addCase(subscribedStatus.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default subscribedStatusSlice.reducer;
